// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact.css */

/* Overall container and background with a subtle gradient */
.contact-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #303030;
  padding: 2rem;
  font-family: 'Inter', sans-serif;
  margin-top: 80px;
}

.contact-container.dark-mode {
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
}

/* The card that holds the form with a soft, rounded look and a hover effect */
.contact-card {
  width: 100%;
  max-width: 35%;
  background-color: #ffffff;
  border-radius: 1.5rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08), 0 6px 6px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  animation: fadeIn 0.8s ease-out;
}

.contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1), 0 8px 8px rgba(0, 0, 0, 0.15);
}

.contact-container.dark-mode .contact-card {
  background-color: #2d3748;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3), 0 6px 6px rgba(0, 0, 0, 0.2);
}

.contact-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 1rem;
  text-align: center;
  position: relative;
  letter-spacing: -1px;
}

.contact-container.dark-mode .contact-title {
  color: #e2e8f0;
}

.contact-title::after {
  content: '';
  display: block;
  width: 50px;
  height: 4px;
  background-color: #4f46e5;
  margin: 0.5rem auto 0;
  border-radius: 2px;
}

@media (min-width: 768px) {
  .contact-title {
    font-size: 2.5rem;
  }
}

.contact-subtitle {
  color: #718096;
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.125rem;
}

.contact-container.dark-mode .contact-subtitle {
  color: #a0aec0;
}

.contact-form {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3.5rem;
}

@media (min-width: 768px) {
  .form-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.contact-container.dark-mode .form-label {
  color: #cbd5e0;
}

.form-input {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease-in-out;
}

.contact-container.dark-mode .form-input {
  background-color: #4a5568;
  border-color: #4a5568;
  color: #f7fafc;
}

.form-input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.3);
}

.form-input:hover {
  border-color: #a0aec0;
}

.form-submit-wrapper {
  display: flex;
  justify-content: center;
}

/* The submit button with a gradient and hover effect */
.submit-button {
  width: 100%;
  padding: 1rem 2rem;
  background: linear-gradient(to right, #6366f1, #4f46e5);
  color: #ffffff;
  font-weight: 700;
  border-radius: 9999px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  border: none;
  cursor: pointer;
}

.submit-button:hover {
  background: linear-gradient(to right, #4f46e5, #3730a3);
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.submit-button:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.5);
}

@media (min-width: 768px) {
  .submit-button {
    width: auto;
  }
}

/* Keyframe animation for a subtle fade-in effect on load */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Contact.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yEAAyE;EACzE,aAAa;EACb,mEAAmE;EACnE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;EACzB,wEAAwE;AAC1E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,kBAAkB;EAClB,uDAAuD;EACvD,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,mEAAmE;EACnE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uDAAuD;EACvD,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* Contact.css */\n\n/* Overall container and background with a subtle gradient */\n.contact-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: #303030;\n  padding: 2rem;\n  font-family: 'Inter', sans-serif;\n  margin-top: 80px;\n}\n\n.contact-container.dark-mode {\n  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n}\n\n/* The card that holds the form with a soft, rounded look and a hover effect */\n.contact-card {\n  width: 100%;\n  max-width: 35%;\n  background-color: #ffffff;\n  border-radius: 1.5rem;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08), 0 6px 6px rgba(0, 0, 0, 0.1);\n  padding: 3rem;\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  animation: fadeIn 0.8s ease-out;\n}\n\n.contact-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1), 0 8px 8px rgba(0, 0, 0, 0.15);\n}\n\n.contact-container.dark-mode .contact-card {\n  background-color: #2d3748;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3), 0 6px 6px rgba(0, 0, 0, 0.2);\n}\n\n.contact-title {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: #1a202c;\n  margin-bottom: 1rem;\n  text-align: center;\n  position: relative;\n  letter-spacing: -1px;\n}\n\n.contact-container.dark-mode .contact-title {\n  color: #e2e8f0;\n}\n\n.contact-title::after {\n  content: '';\n  display: block;\n  width: 50px;\n  height: 4px;\n  background-color: #4f46e5;\n  margin: 0.5rem auto 0;\n  border-radius: 2px;\n}\n\n@media (min-width: 768px) {\n  .contact-title {\n    font-size: 2.5rem;\n  }\n}\n\n.contact-subtitle {\n  color: #718096;\n  text-align: center;\n  margin-bottom: 2rem;\n  font-size: 1.125rem;\n}\n\n.contact-container.dark-mode .contact-subtitle {\n  color: #a0aec0;\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3.5rem;\n}\n\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-label {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n}\n\n.contact-container.dark-mode .form-label {\n  color: #cbd5e0;\n}\n\n.form-input {\n  display: block;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background-color: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease-in-out;\n}\n\n.contact-container.dark-mode .form-input {\n  background-color: #4a5568;\n  border-color: #4a5568;\n  color: #f7fafc;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.3);\n}\n\n.form-input:hover {\n  border-color: #a0aec0;\n}\n\n.form-submit-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n/* The submit button with a gradient and hover effect */\n.submit-button {\n  width: 100%;\n  padding: 1rem 2rem;\n  background: linear-gradient(to right, #6366f1, #4f46e5);\n  color: #ffffff;\n  font-weight: 700;\n  border-radius: 9999px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  border: none;\n  cursor: pointer;\n}\n\n.submit-button:hover {\n  background: linear-gradient(to right, #4f46e5, #3730a3);\n  transform: translateY(-3px) scale(1.02);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);\n}\n\n.submit-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.5);\n}\n\n@media (min-width: 768px) {\n  .submit-button {\n    width: auto;\n  }\n}\n\n/* Keyframe animation for a subtle fade-in effect on load */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
